import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_USER + name;
};

export const PathnameUsers = {
  LANDING_PAGE: "/",
  USER: "/user",
  ROLE: "/role",
  LANGUAGE: "/language",
  FORMS: "/setting/forms",
  CUSTOM_FORM: "/setting/forms/custom-form",
  ADD_USER: "/user/add-user",
  EDIT_USER: "/user/:id/edit-user",
  VIEW_USER: "/user/:id/view-user",
  ADD_ROLE: "/role/add-role",
  EDIT_ROLE: "/role/:id/edit-role",
  VIEW_ROLE: "/role/:id/view-role",
  WORK: "/setting/works",
  ADD_WORKFLOW: "/setting/works/workflow",
  ADD_LANGUAGE: "/language/add-language",
  EDIT_LANGUAGE: "/language/:id/edit-language",
  VIEW_LANGUAGE: "/language/:id/view-language",
  // EMAILS: "/setting/emails",
  // ADD_EMAIL_TEMPLATE: "/setting/emails/:id/add-template",
  // EDIT_EMAIL_TEMPLATE: "/setting/emails/:id/edit-template/:template_id",
};
